export interface Activity {
    id: number;
    name: string;
}

export interface Indicator {
    id: number;
    code: string;
    name: string;
    order: number;
}

export interface IndicatorValue {
    indicatorId: number;
    value: number;
}

/** Mirrors the backend RecalculationStatus enum. */
export const RECALCULATION_STATUS = {
    QUEUED: 'QUEUED',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
} as const;

export type RecalculationStatus = typeof RECALCULATION_STATUS[keyof typeof RECALCULATION_STATUS];

export interface ActivityIndicatorConfig {
    id: number;
    datasetID: string;
    activityId: number;
    indicatorValues: IndicatorValue[];
    status?: RecalculationStatus;
    /** Epoch millis, as stored by the backend. Absent until a profile is first saved. */
    createdOn?: number;
    updatedOn?: number;
}

export const NOT_APPLICABLE_PROFILE = 'NOT APPLICABLE';

export function isNotApplicableProfile(name: string | null | undefined): boolean {
    return (name || '').trim().toUpperCase() === NOT_APPLICABLE_PROFILE;
}
